define("Tavano.TTPDPLeadTime.TTPDPLeadTime",
  [
    "Tavano.TTPDPLeadTime.TTPDPLeadTime.View"
  ],
  function (
    TTPDPLeadTimeView
  ) {
    "use strict";

    return {
      mountToApp: function mountToApp(container) {

        /** @type {LayoutComponent} */
        var layout = container.getComponent("Layout");
        var pdp = container.getComponent("PDP");
        var cart = container.getComponent("Cart");

        if (layout) {
          layout.addChildView("TTProduct.LeadTime", function () {
            return new TTPDPLeadTimeView({
              container: container,
              cart: cart,
              pdp: pdp
            });
          });
        }
      }
    };
  });
